module.exports = "/_next/static/images/36a15f811b870803d076a5cfc05a1e3e-icon-3.svg.webp";